export default __webpack_public_path__ + "static/media/ladies-special-homepage-package.2ebffe8d.jpg";